import React from 'react';
import { Pressable, Image, StyleSheet } from 'react-native-web';

const IconButton = ({ 
    source, 
    onPress, 
    size = 20, 
    style,
    accessible = true,
    accessibilityLabel,
    accessibilityRole = "button",
    containerStyle,
    disabled = false
}) => {
    return (
        <Pressable
            style={({ hovered }) => [
                styles.container,
                containerStyle,
                hovered && !disabled && styles.iconHovered,
                disabled && styles.disabled
            ]}
            onPress={disabled ? undefined : onPress}
            accessible={accessible}
            accessibilityLabel={accessibilityLabel}
            accessibilityRole={accessibilityRole}
            disabled={disabled}
        >
            <Image 
                style={[
                    styles.icon,
                    { height: size, width: size },
                    style,
                    disabled && styles.iconDisabled
                ]} 
                source={source}
            />
        </Pressable>
    );
};

const styles = StyleSheet.create({
    container: {
        padding: 4,
        borderRadius: 6,
        transition: 'all 0.2s ease',
        cursor: 'pointer',
    },
    icon: {
        resizeMode: 'contain',
    },
    iconHovered: {
        transform: [{ scale: 1.1 }],
    },
    disabled: {
        cursor: 'not-allowed',
        opacity: 0.5,
    },
    iconDisabled: {
        opacity: 0.5,
    },
});

export default IconButton;